import { Component, OnInit } from '@angular/core';
import { CommonModule, NgIf } from '@angular/common';
import { DataFetcherService } from '../../../services/data-fetcher/data-fetcher.service';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';

@Component({
  selector: 'app-dataset-info',
  standalone: true,
  imports: [RouterLink, CommonModule],
  templateUrl: './dataset-info.component.html',
  styleUrl: './dataset-info.component.css'
})
export class DatasetInfoComponent {
  newUrl: string = '';
  dataset: any;  // Array to store the list of datasets
  datasetId: string | undefined; //Get the datasetId for API request

  constructor(private dataFetcher: DataFetcherService, private route: ActivatedRoute, private router: Router) {}

  ngOnInit() {
    // Access  the dataset ID from the route parameters
    this.route.params.subscribe(params => {
      this.datasetId = params['datasetId'];  // Workspace ID
      this.newUrl = this.router.url.toString().replace('/dataset/'+this.datasetId, '');
    });
    // Fetch the dataset data when the component initializes
    this.dataFetcher.GetDatasetByIdData(this.datasetId).subscribe(
      (data: any) => {
        // Extract the 'datasets' array from the data object
        this.dataset = data.datasets[0] || null;  // Fallback to an empty array if 'datasets' is undefined
      },
      (error) => {
        console.error('Error fetching dataset data', error);
      }
    );
    console.log(this.dataset);
  }
}

